var map = {
	"./dialogs/dialogs.de_DE.js": 29511,
	"./dialogs/dialogs.en_US.js": 28081,
	"./dialogs/dialogs.fr_FR.js": 51761,
	"./dialogs/dialogs.js": 12010,
	"./dialogs/dialogs.nb_NO.js": 77817,
	"./fonts.js": 13968,
	"./icons/icons.js": 4651,
	"./langs.js": 25588,
	"./loading/loading.de_DE.js": 2726,
	"./loading/loading.en_US.js": 41525,
	"./loading/loading.fr_FR.js": 52224,
	"./loading/loading.js": 50878,
	"./loading/loading.nb_NO.js": 86741,
	"./map/map.de_DE.js": 21978,
	"./map/map.en_US.js": 9018,
	"./map/map.fr_FR.js": 32514,
	"./map/map.js": 27818,
	"./map/map.nb_NO.js": 44674,
	"./menu/menu.de_DE.js": 47002,
	"./menu/menu.en_US.js": 33211,
	"./menu/menu.fr_FR.js": 95424,
	"./menu/menu.js": 65889,
	"./menu/menu.nb_NO.js": 8141,
	"./scenes/scenes.js": 73344,
	"./sounds/sounds.js": 85428,
	"./splashscreen/splashscreen.js": 4781,
	"./tutorial/tutorial.js": 49741,
	"./videos/videos.js": 94487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87134;